import { TrackingParamsRepository } from './types';
import { getUniversalParams } from './ga';
import { getMktportalParams } from './mktportal';
import { getUtmParameters } from './utm';

export const createTrackingParamsRepository = (): TrackingParamsRepository => {
  return {
    getUtmParams: getUtmParameters,
    getMktportalParams,
    getGaParams: getUniversalParams,
  };
};
